 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dice_one":"dice_one","spin_to_win":"spin_to_win","game_lounge":"game_lounge","home":"home","item_index":"item_index","item_show":"item_show","nft_import":"nft_import","player_index":"player_index","player_show":"player_show","room_index":"room_index","room_show":"room_show","saga_index":"saga_index","saga_item_index":"saga_item_index","saga_show":"saga_show","visit_room":"visit_room"}[chunkId]||chunkId) + "." + {"chunk-188a78cc":"cd80a642","chunk-4ee8b798":"cf3ca6b5","chunk-7984f7eb":"8f6fbd90","dice_one":"74700b5f","spin_to_win":"94c7cca5","game_lounge":"8be62710","home":"f98b40a2","item_index":"c8f84612","item_show":"fb98f4f8","nft_import":"e6c9671c","player_index":"2eaf48fe","player_show":"dcf767f4","room_index":"87ab1141","room_show":"a9a769d6","saga_index":"b466d89b","saga_item_index":"e6e34afb","saga_show":"e3daac3c","visit_room":"46c96889","chunk-41109c45":"9f5ebfbf","chunk-0b9714be":"120e69b6","chunk-ef5c7e98":"2f69a057","chunk-2d572818":"5b600382","chunk-2e08036d":"805646d8","chunk-405055cd":"34c7c241","chunk-fa55e4d0":"c3f3647e","chunk-18740b35":"33bbc350","chunk-bb4c1966":"6eac98b0","chunk-f10aafde":"bc8c198d","chunk-2f41a889":"06a3cb08","chunk-742cd5f0":"1c0bedaa","chunk-9e50c666":"c03fc398","chunk-0362005c":"3ff74ca5","chunk-1651bcae":"abad47e7","chunk-1b0b6b55":"58232bb5","chunk-1e12379a":"d65c6bd6","chunk-200d8bce":"414a5617","chunk-22243168":"92df8c71","chunk-2d0d3e25":"dfc1722b","chunk-2d0d9f56":"a4df87af","chunk-2d0ddfb0":"cdf665ef","chunk-2d0e4565":"04c2c594","chunk-2d215cfc":"ce86b479","chunk-35497a45":"5065ef4b","chunk-4c301502":"1872f80d","chunk-5f64272a":"94a41779","chunk-614220de":"6d4c9baa","chunk-665aeb87":"48ab0206","chunk-73b200a5":"26632860","chunk-92c96a1c":"33a404bb","chunk-9e9a3656":"c143ce3d","chunk-ceed158a":"24ccba29","chunk-db95c098":"ddfd8402","chunk-07a6d3df":"f6c9dfc6","chunk-2d0e8f93":"3b6da2b8","chunk-61a7dcfd":"6354e6b5","chunk-6c220555":"93ab863c","chunk-05ffd7b9":"052e71a9","chunk-48e80db1":"dcf35333","chunk-58d59db1":"6e9950dd","chunk-43d59872":"4da05fa1","chunk-aeee4550":"464364d4","chunk-d2899ce6":"62310b45","chunk-5b89ad9e":"fc6a4e39","chunk-9e80ff1e":"c715ebe3","chunk-474b78e6":"907faef1","chunk-6aaccf58":"051dbb58","chunk-770b8d9a":"a493ab03","chunk-26c579fd":"24705295","chunk-5f31bb51":"8b7cbff0","chunk-39e5b706":"4aee3ab5","chunk-7ef8d156":"8f6afc0a","chunk-ca955434":"6875b1e6","chunk-2097ef96":"0e94686a","chunk-2d0c5527":"09fddb6a","chunk-c79fbd70":"7d5ecd2e","chunk-2d230122":"c7e9f764","chunk-4c050e85":"75730c99","chunk-6b11db85":"cadad9aa","chunk-0d6337f1":"f157328c","chunk-2d02e288":"988ac68b","chunk-141553b0":"19ea6903","chunk-ce211a7c":"815782ad","chunk-2323eb4f":"2823a53b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-188a78cc":1,"chunk-4ee8b798":1,"dice_one":1,"spin_to_win":1,"home":1,"item_index":1,"item_show":1,"nft_import":1,"player_index":1,"player_show":1,"room_index":1,"room_show":1,"saga_item_index":1,"saga_show":1,"visit_room":1,"chunk-0b9714be":1,"chunk-2d572818":1,"chunk-2e08036d":1,"chunk-fa55e4d0":1,"chunk-18740b35":1,"chunk-bb4c1966":1,"chunk-742cd5f0":1,"chunk-9e50c666":1,"chunk-0362005c":1,"chunk-1651bcae":1,"chunk-1b0b6b55":1,"chunk-1e12379a":1,"chunk-200d8bce":1,"chunk-22243168":1,"chunk-35497a45":1,"chunk-4c301502":1,"chunk-5f64272a":1,"chunk-614220de":1,"chunk-665aeb87":1,"chunk-73b200a5":1,"chunk-92c96a1c":1,"chunk-9e9a3656":1,"chunk-ceed158a":1,"chunk-db95c098":1,"chunk-07a6d3df":1,"chunk-61a7dcfd":1,"chunk-6c220555":1,"chunk-05ffd7b9":1,"chunk-48e80db1":1,"chunk-58d59db1":1,"chunk-43d59872":1,"chunk-aeee4550":1,"chunk-d2899ce6":1,"chunk-5b89ad9e":1,"chunk-9e80ff1e":1,"chunk-474b78e6":1,"chunk-6aaccf58":1,"chunk-26c579fd":1,"chunk-5f31bb51":1,"chunk-39e5b706":1,"chunk-7ef8d156":1,"chunk-ca955434":1,"chunk-2097ef96":1,"chunk-c79fbd70":1,"chunk-4c050e85":1,"chunk-6b11db85":1,"chunk-0d6337f1":1,"chunk-2d02e288":1,"chunk-141553b0":1,"chunk-ce211a7c":1,"chunk-2323eb4f":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dice_one":"dice_one","spin_to_win":"spin_to_win","game_lounge":"game_lounge","home":"home","item_index":"item_index","item_show":"item_show","nft_import":"nft_import","player_index":"player_index","player_show":"player_show","room_index":"room_index","room_show":"room_show","saga_index":"saga_index","saga_item_index":"saga_item_index","saga_show":"saga_show","visit_room":"visit_room"}[chunkId]||chunkId) + "." + {"chunk-188a78cc":"54e02770","chunk-4ee8b798":"c370da64","chunk-7984f7eb":"31d6cfe0","dice_one":"819ebe7d","spin_to_win":"a53f8a44","game_lounge":"31d6cfe0","home":"344c220e","item_index":"59a4f0a5","item_show":"3c75b8c0","nft_import":"49aa6b6e","player_index":"3eb8b9ca","player_show":"6eee5718","room_index":"0b7ecc4b","room_show":"899093dd","saga_index":"31d6cfe0","saga_item_index":"ccf4692e","saga_show":"12cb0512","visit_room":"a63d8ea7","chunk-41109c45":"31d6cfe0","chunk-0b9714be":"e8fd5ead","chunk-ef5c7e98":"31d6cfe0","chunk-2d572818":"d52f8f7f","chunk-2e08036d":"0c4da26b","chunk-405055cd":"31d6cfe0","chunk-fa55e4d0":"24ada7c1","chunk-18740b35":"870351bd","chunk-bb4c1966":"ec62cea8","chunk-f10aafde":"31d6cfe0","chunk-2f41a889":"31d6cfe0","chunk-742cd5f0":"5f6ebe26","chunk-9e50c666":"ec9fb08b","chunk-0362005c":"7be9eeab","chunk-1651bcae":"45017693","chunk-1b0b6b55":"88b1431a","chunk-1e12379a":"91262a51","chunk-200d8bce":"e2c75771","chunk-22243168":"e693da7c","chunk-2d0d3e25":"31d6cfe0","chunk-2d0d9f56":"31d6cfe0","chunk-2d0ddfb0":"31d6cfe0","chunk-2d0e4565":"31d6cfe0","chunk-2d215cfc":"31d6cfe0","chunk-35497a45":"0c4da26b","chunk-4c301502":"dc3d8e2d","chunk-5f64272a":"2be94b7b","chunk-614220de":"a84f9681","chunk-665aeb87":"db448396","chunk-73b200a5":"8a8b2071","chunk-92c96a1c":"4e78c86d","chunk-9e9a3656":"a575e6e1","chunk-ceed158a":"806598c7","chunk-db95c098":"7d5c72a6","chunk-07a6d3df":"1fecf4b4","chunk-2d0e8f93":"31d6cfe0","chunk-61a7dcfd":"998ef761","chunk-6c220555":"f8df728c","chunk-05ffd7b9":"f06adcd8","chunk-48e80db1":"2a97183a","chunk-58d59db1":"53a6910e","chunk-43d59872":"d7e5c93f","chunk-aeee4550":"0347ec87","chunk-d2899ce6":"341f7a2a","chunk-5b89ad9e":"88b1431a","chunk-9e80ff1e":"a56b9068","chunk-474b78e6":"9b310d25","chunk-6aaccf58":"87a18ca2","chunk-770b8d9a":"31d6cfe0","chunk-26c579fd":"29f7f37e","chunk-5f31bb51":"b9efaaf3","chunk-39e5b706":"b76cf47b","chunk-7ef8d156":"9a79a7e8","chunk-ca955434":"efbaa22c","chunk-2097ef96":"e4766b21","chunk-2d0c5527":"31d6cfe0","chunk-c79fbd70":"f1adfff7","chunk-2d230122":"31d6cfe0","chunk-4c050e85":"7a89cf96","chunk-6b11db85":"afeaeb29","chunk-0d6337f1":"e35f276c","chunk-2d02e288":"4f2efc1c","chunk-141553b0":"42851960","chunk-ce211a7c":"d55d9645","chunk-2323eb4f":"7aecbe13"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
